import { types } from 'mobx-state-tree';

const MessageEvent = types.model('Event', {
  data: types.frozen(),
});

export default MessageEvent;
